module.exports = __webpack_public_path__ + "27b75622d78a5a528ddb94ef1cbed858.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-16@2x.png
// module id = 504
// module chunks = 0